import { combineReducers } from "@reduxjs/toolkit";
import orders from "./orders";
import stopUnitTemplates from "./stop-unit-templates";
import cargoTypes from "./cargo-types";

export default combineReducers({ orders, stopUnitTemplates, cargoTypes });
